import Vue from 'vue'
const lang = require('vuejs-localization')

// Notice that you need to specify the lang folder, in this case './lang'
lang.requireAll(require.context('./lang', true, /\.js$/))

//Import to vue component
Vue.use(lang);